import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-footer-notification',
  templateUrl: './footer-notification.component.html',
  styleUrls: ['./footer-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterNotificationComponent implements OnInit {
  @Input()
  label: string;

  @Input()
  buttonLabel: string;

  @Input()
  compact: boolean;

  @Output()
  dismissClick = new EventEmitter();

  @Output()
  actionClick = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  handleActionClick() {
    this.actionClick.emit();
  }

  handleDismissClick() {
    this.dismissClick.emit();
  }
}
